import { Tooltip } from '@material-ui/core';
import React from 'react';

import { ITextProps, Text } from '~/src/dash/components/text/Text';

interface ITextWithTooltipProps extends ITextProps {
  tooltip: string;
}

export const TextWithTooltip = ({
  tooltip,
  // <Text> props
  // presets
  header,
  subheader,
  title,
  // size
  mini,
  extraSmall,
  small,
  baseSize,
  large,
  extraLarge,
  sizeV2, // rem
  // color
  color,
  muted,
  baseColor,
  highlighted,
  // weight
  baseWeight,
  bold,
  heavy,
  // font style
  italic,
  // layout
  inlineBlock,
  // misc
  disableSelect,
  // standard
  style,
  className = '',
  children,
  cypressID,
}: ITextWithTooltipProps) => {
  return (
    <Tooltip title={tooltip}>
      <div>
        <Text
          header={header}
          subheader={subheader}
          title={title}
          // size
          mini={mini}
          extraSmall={extraSmall}
          small={small}
          baseSize={baseSize}
          large={large}
          extraLarge={extraLarge}
          sizeV2={sizeV2} // rem
          // color
          color={color}
          muted={muted}
          baseColor={baseColor}
          highlighted={highlighted}
          // weight
          baseWeight={baseWeight}
          bold={bold}
          heavy={heavy}
          // font style
          italic={italic}
          // layout
          inlineBlock={inlineBlock}
          // misc
          disableSelect={disableSelect}
          // standard
          style={style}
          className={className}
          cypressID={cypressID}
        >
          {children}
        </Text>
      </div>
    </Tooltip>
  );
};
